import { useState } from 'react';

export default function useFilterDataTable() {
    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

    return [filterText, setFilterText, resetPaginationToggle, setResetPaginationToggle];
}
